/* Naguirre — medição da gaveta (leva E, 13/10/2026). Carregado por snippets/ng-medicao.liquid.
   Manda ao Ledger, numa porta só dele (POST https://n.naguirreshop.com.br/gaveta, tabela marketing.evento_gaveta),
   o que acontece na gaveta, na página /cart e no frete da página do produto. Contrato v1: DESENHO-MEDICAO.md da
   leva E (seção 2) e docs/GAVETA-EVENTOS.md do naguirre-marketing.
   - Não passa pelo pixel nem pelo /t: nenhum evento daqui chega à Meta ou ao GA4, e nenhum evento que já existe muda.
     Não cria elemento, não muda texto e não pede nada à loja: o único pedido de rede é o beacon ao Ledger.
   - Um evento por ação: window.ngMedir(nome, campos) é chamado uma vez, no fim do tratamento de cada ação (os
     ganchos de naguirre-gaveta.js e naguirre-frete.js), ou por um observador daqui. O redesenho da gaveta nunca
     dispara evento. O id de cada evento é "<pv>:<sequência>", único na página; o Ledger tira repetidos por ele.
   - Eventos: gaveta_aberta, cupom_aplicado, cupom_removido, cupom_desfeito, frete_calculado, meta_atingida,
     sugestoes_vistas, sugestao_tocada e finalizar_tocado; e, do convite do Grupo VIP (naguirre-vip.js, 14/10),
     vip_visto, vip_tocado e vip_fechado (contrato: selos-vip/CONTRATO-VIP.md).
   - Só sai com o consentimento de análise da Shopify (o mesmo portão do ng-erros e da RUM). Se a API de
     consentimento ainda não carregou, espera um pouco; sem resposta, não manda.
   - Nada pessoal: nunca o CEP (só a UF), nunca o código do cupom (só a família), nunca texto livre, endereço com
     query ou id de cliente. O "cid" é o identificador de visitante que a própria Shopify põe no Server-Timing da
     página (_y, o mesmo formato do client_id do pixel); o "pv" é um número aleatório desta carga de página.
   - Teto de 60 eventos por página (corta laço). Hora da ação pelo relógio da página (t e ag), nunca o do aparelho.
   Chave do editor "Desligar a medição" (Naguirre — medição): ligada, este arquivo nem carrega. */
(function () {
  'use strict';
  var w = window, d = document, n = navigator;
  if (w.ngMedir || !w.JSON || typeof d.addEventListener !== 'function' || !d.body) return;

  var cfg = w.ngMedicao || {};
  var DESTINO = 'https://n.naguirreshop.com.br/gaveta';
  var TETO = 60;
  // Os 3 últimos são do convite do Grupo VIP (assets/naguirre-vip.js, 14/10): só Ledger, nunca Meta nem GA4.
  var NOMES = ['gaveta_aberta', 'cupom_aplicado', 'cupom_removido', 'cupom_desfeito', 'frete_calculado',
    'meta_atingida', 'sugestoes_vistas', 'sugestao_tocada', 'finalizar_tocado', 'vip_visto', 'vip_tocado', 'vip_fechado'];
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
  var FRETES = ['f1', 'f2', 'f2g', 'f3', 'fx'];
  var PRESENTES = ['g1', 'g1p', 'g2'];

  function agora() { try { return Math.round(w.performance.now()); } catch (e) { return 0; } }
  function inteiro(v, min, max) {
    var x = parseInt(v, 10);
    return isNaN(x) ? min : Math.max(min, Math.min(max, x));
  }
  function lerSessao(chave) { try { return JSON.parse(w.sessionStorage.getItem(chave) || 'null'); } catch (e) { return null; } }
  function gravarSessao(chave, valor) { try { w.sessionStorage.setItem(chave, JSON.stringify(valor)); } catch (e) {} }

  // ---------- Identificadores ----------
  function novoId() {
    try {
      if (w.crypto && typeof w.crypto.randomUUID === 'function') {
        var u = String(w.crypto.randomUUID()).toLowerCase();
        if (UUID.test(u)) return u;
      }
    } catch (e) {}
    try {
      var b = new Uint8Array(16);
      w.crypto.getRandomValues(b);
      b[6] = (b[6] & 15) | 64;
      b[8] = (b[8] & 63) | 128;
      var h = '';
      for (var i = 0; i < 16; i++) h += (b[i] + 256).toString(16).slice(1);
      return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20);
    } catch (e) {}
    return null;
  }
  var pv = novoId(); // sem gerador de números aleatórios (navegador muito antigo), nada é medido
  // O identificador de visitante da Shopify (_y) vem no Server-Timing da página: os cookies dela agora são HttpOnly.
  // Safari abaixo de 16.4 não mostra o serverTiming: aí cid = null (o evento conta só nos agregados).
  var cid = null;
  try {
    var navegacao = w.performance.getEntriesByType('navigation')[0];
    var st = (navegacao && navegacao.serverTiming) || [];
    for (var i = 0; i < st.length; i++) {
      if (st[i].name !== '_y') continue;
      var y = String(st[i].description || '').toLowerCase();
      if (UUID.test(y)) cid = y;
      break;
    }
  } catch (e) { cid = null; }
  // Reserva da aba: o último _y válido desta visita (sessionStorage ngMedCid). Na bancada do X, o WebKit chegou à página
  // aberta por toque num link com a medida da navegação zerada (sem Server-Timing), e a 1ª página da visita tinha o _y.
  // Ler não grava nada; o _y desta página só é guardado com o consentimento de análise (guardarCid: no envio, na carga
  // e na saída da página), o mesmo portão do envio.
  var cidDaPagina = cid;
  var cidGuardado = false;
  if (!cid) {
    try {
      var daAba = String(w.sessionStorage.getItem('ngMedCid') || '');
      if (UUID.test(daAba)) cid = daAba;
    } catch (e) {}
  }
  function guardarCid() {
    if (cidGuardado || !cidDaPagina) return;
    cidGuardado = true;
    try { w.sessionStorage.setItem('ngMedCid', cidDaPagina); } catch (e) {}
  }

  // ---------- Envio ----------
  var seq = 0;
  var aceitos = 0;
  var fila = [];
  var esperas = 0;
  var relogio = 0;
  // true, false ou null (a API de consentimento da Shopify ainda não carregou).
  function consentimento() {
    try {
      var cp = w.Shopify && w.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return null;
      return cp.analyticsProcessingAllowed() === true;
    } catch (e) { return null; }
  }
  function envelope(lote) {
    var tema = 0;
    try { tema = (w.Shopify && w.Shopify.theme && w.Shopify.theme.id) || 0; } catch (e) {}
    return { v: 1, tema: tema, pg: String(cfg.pg || ''), ap: ((w.innerWidth || 0) / 10 | 0) * 10, teste: w.ngTeste ? 1 : 0,
      cid: cid, pv: pv, ag: agora(), ev: lote };
  }
  function postar(corpo) {
    var foi = false;
    try { foi = typeof n.sendBeacon === 'function' && n.sendBeacon(DESTINO, corpo) === true; } catch (e) { foi = false; }
    if (foi) return;
    try {
      // Reserva sem preflight: corpo de texto, sem cookies, sobrevive à troca de página.
      var p = w.fetch(DESTINO, { method: 'POST', body: corpo, keepalive: true, mode: 'no-cors', credentials: 'omit' });
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } catch (e) {}
  }
  function despachar() {
    if (!fila.length) return;
    var ok = consentimento();
    if (ok === null) {
      // A API carrega com o tema (layout/theme.liquid, ponte do Shopify Forms); espera até ~16 s e desiste.
      if (esperas >= 8) { fila.length = 0; return; }
      if (!relogio) relogio = setTimeout(function () { relogio = 0; esperas++; despachar(); }, 500 + esperas * 250);
      return;
    }
    if (!ok) { fila.length = 0; return; }
    guardarCid();
    while (fila.length) postar(JSON.stringify(envelope(fila.splice(0, 10))));
  }
  // nome: um dos 12; campos: só os do contrato (undefined fica de fora); t: hora da ação (padrão: agora).
  function medir(nome, campos, t) {
    try {
      if (!pv || NOMES.indexOf(nome) === -1 || aceitos >= TETO || seq >= 999) return false;
      var ev = { id: pv + ':' + (++seq), e: nome, t: typeof t === 'number' ? Math.round(t) : agora() };
      if (campos) {
        for (var k in campos) {
          if (Object.prototype.hasOwnProperty.call(campos, k) && campos[k] !== undefined && k !== 'id' && k !== 'e' && k !== 't') ev[k] = campos[k];
        }
      }
      aceitos++;
      // O fim de uma ação de cupom (digitado) ou de frete também conta como ação desta página (meta_atingida, seção 6):
      // cobre a conta ou a escrita que demora mais que a janela contada do toque.
      if (nome === 'cupom_removido' || (nome === 'cupom_aplicado' && ev.via === 'digitado')) acoes.carrinho = ev.t;
      else if (nome === 'frete_calculado') acoes.frete = ev.t;
      fila.push(ev);
      despachar();
      return true;
    } catch (e) { return false; }
  }

  // ---------- Vocabulários (o que sai no lugar do texto) ----------
  // Família do cupom pelo código, sem o código: LIVE…, …FRETE…, NIVER…, vale-presente (16 letras e números com pelo
  // menos um número: o "<NOME>AUT" de consultora, só letras, fica em "outro") e outro.
  function familia(codigo) {
    var c = String(codigo || '').toUpperCase();
    if (/^LIVE/.test(c)) return 'live';
    if (/FRETE/.test(c)) return 'frete';
    if (/^NIVER/.test(c)) return 'aniversario';
    if (/^[A-Z0-9]{16}$/.test(c) && /[0-9]/.test(c) && /[A-Z]/.test(c)) return 'vale';
    return 'outro';
  }
  function servico(nome) {
    var s = String(nome || '').toLowerCase();
    if (/jadlog/.test(s)) return 'jadlog';
    if (/sedex/.test(s)) return 'sedex';
    if (/econ[oô]mic/.test(s)) return 'economico';
    if (/r[aá]pid|expres/.test(s)) return 'rapido';
    return 'outro';
  }
  // Prazo em dias úteis: o maior número do texto ("3 dias úteis" = 3; "2 a 5 dias úteis" = 5); sem número, null.
  function prazo(texto) {
    var m = String(texto || '').match(/\d+/g);
    if (!m) return null;
    var maior = -1;
    for (var i = 0; i < m.length; i++) maior = Math.max(maior, parseInt(m[i], 10));
    return maior >= 0 && maior <= 60 ? maior : null;
  }
  function estadoDe(el, lista) {
    var v = el ? String(el.getAttribute('data-ng-estado') || '') : '';
    return lista.indexOf(v) !== -1 ? v : '';
  }
  function handleDe(href) {
    var m = /\/products\/([^\/?#]+)/.exec(String(href || ''));
    if (!m) return undefined;
    var h = m[1];
    try { h = decodeURIComponent(h); } catch (e) {}
    h = h.toLowerCase();
    return /^[a-z0-9-]{1,120}$/.test(h) ? h : undefined;
  }

  // ---------- Estado da gaveta (e da página /cart) ----------
  // Peças (contador do tema), total depois das promoções, metas (data-ng-estado do Liquid), cupons do painel e brinde.
  function lerCarrinhoNaTela(detalhe, naPagina) {
    var g = d.getElementById('halo-cart-sidebar');
    var lugar = naPagina ? d.getElementById('main-cart-items') : g;
    var r = { itens: 0, total: 0, meta_frete: '', meta_presente: '', cupons: 0, brinde: false };
    var contador = d.querySelector('[data-cart-count]');
    r.itens = detalhe && typeof detalhe.item_count === 'number' ? inteiro(detalhe.item_count, 0, 999) : inteiro(contador && contador.textContent, 0, 999);
    var total = lugar && lugar.querySelector('[data-cart-total-value]');
    r.total = inteiro(total && total.getAttribute('data-cart-total-value'), 0, 10000000);
    var cupons = lugar && lugar.querySelector('[data-ng-cupons-ativos]');
    if (cupons) r.cupons = inteiro(String(cupons.getAttribute('data-ng-cupons-ativos') || '').split('|').filter(Boolean).length, 0, 10);
    if (g) {
      r.meta_frete = estadoDe(g.querySelector('[data-ng-meta-frete]'), FRETES);
      r.meta_presente = estadoDe(g.querySelector('[data-ng-meta-presente]'), PRESENTES);
      r.brinde = !!g.querySelector('.previewCartItem--brinde, .previewCartItem--gift');
    }
    return r;
  }

  // ---------- Toques (fase de captura; nada é impedido nem atrasado) ----------
  var corpo = d.body;
  var toques = { produto: -1e9, card: -1e9, icone: -1e9, gaveta: -1e9, qualquer: -1e9 };
  var carga = 0;
  w.addEventListener('load', function () { carga = agora(); });
  var aberta = corpo.classList.contains('cart-sidebar-show');
  var sug = null; // "Você também pode gostar" nesta abertura
  var rolouGaveta = false;
  // Ações da cliente NESTA página que mudam o carrinho (Adicionar, +, −, remover, quantidade digitada, aplicar ou tirar
  // cupom) ou o frete (calcular na gaveta ou no produto). Só elas abrem a janela de 20 s em que uma meta cruzada conta
  // como meta_atingida (revisão de 13/10: sem ação, a leitura só guarda). Abrir a gaveta, rolar, abrir as linhas de
  // cupom e de frete e tocar num produto não são ações.
  var SEL_ACAO_CARRINHO = '[data-btn-addtocart], [data-minus-quantity-cart], [data-plus-quantity-cart], [data-cart-remove], ' +
    '[data-ng-aplicar], [data-ng-remover-cupom]';
  var acoes = { carrinho: -1e9, frete: -1e9 };
  function recente(t) { return agora() - t <= 20000; }

  d.addEventListener('click', function (ev) {
    try {
      var el = ev.target;
      if (el && el.nodeType !== 1) el = el.parentElement;
      if (!el || typeof el.closest !== 'function') return;
      var t = agora();
      toques.qualquer = t;
      if (el.closest(SEL_ACAO_CARRINHO)) acoes.carrinho = t;
      else if (el.closest('[data-ng-calcular]')) acoes.frete = t;
      if (el.closest('#halo-cart-sidebar')) toques.gaveta = t;
      else if (el.closest('[data-btn-addtocart]')) {
        if (el.closest('product-form, [data-sticky-add-to-cart]') && !el.closest('.halo-quickshop, .halo-quickView')) toques.produto = t;
        else toques.card = t;
      } else if (el.closest('[data-cart-sidebar], .header__icon--cart')) toques.icone = t;
      if (el.closest('[data-ng-sug-seta]') && sug && !sug.enviado) sug.rolouLista = true;
      var link = el.closest('.ng-sug__link');
      if (link) tocouSugestao(link);
      var fim = el.closest('#cart-sidebar-checkout, #cart-checkout');
      if (fim) tocouFinalizar(fim);
    } catch (e) {}
  }, true);
  // As mesmas ações pelo teclado: Enter no campo do cupom ou do CEP, quantidade digitada e "Adicionar" por Enter.
  d.addEventListener('keydown', function (ev) {
    try {
      var el = ev.target;
      if (ev.key !== 'Enter' || !el || el.nodeType !== 1 || typeof el.matches !== 'function') return;
      if (el.matches('[data-ng-cupom]')) acoes.carrinho = agora();
      else if (el.matches('[data-ng-cep]')) acoes.frete = agora();
    } catch (e) {}
  }, true);
  d.addEventListener('change', function (ev) {
    try {
      var el = ev.target;
      if (el && el.nodeType === 1 && typeof el.closest === 'function' && el.closest('cart-update-quantity, [data-cart-quantity]')) acoes.carrinho = agora();
    } catch (e) {}
  }, true);
  d.addEventListener('submit', function (ev) {
    try {
      var f = ev.target;
      if (f && f.nodeType === 1 && /\/cart\/add/.test(String(f.getAttribute('action') || ''))) acoes.carrinho = agora();
    } catch (e) {}
  }, true);
  // A ação aconteceu na gaveta: o último toque (de todos) foi dentro dela, há até 20 s.
  function naGaveta() { return toques.gaveta === toques.qualquer && agora() - toques.gaveta <= 20000; }

  // ---------- 1. gaveta_aberta ----------
  // Transição de fechada para aberta da classe cart-sidebar-show do <body> (redesenho com ela aberta não conta;
  // mínimo de 1 s entre aberturas). A origem sai do último toque: o "Adicionar" da página do produto (até 10 s antes),
  // o ícone do carrinho (até 3 s), o "Adicionar" de um card ou da compra rápida (até 10 s); sem toque, "carga" (até 2 s
  // depois da carga) ou "app" (outro script abriu); toque em outra coisa, "desconhecido". O estado é lido depois do
  // redesenho que a abertura traz (o tema abre e só então busca a gaveta), no máximo 4 s depois.
  var ultimaAbertura = -1e9;
  function origemDaAbertura(t) {
    var maisRecente = Math.max(toques.produto, toques.card, toques.icone);
    if (t - toques.icone <= 3000 && toques.icone === maisRecente) return { origem: 'icone' };
    if (t - toques.produto <= 10000 && toques.produto === maisRecente) return { origem: 'produto' };
    if (t - toques.card <= 10000 && toques.card === maisRecente) return { origem: 'outro', detalhe: 'card' };
    if (toques.qualquer < 0 && (!carga || t - carga <= 2000)) return { origem: 'outro', detalhe: 'carga' };
    if (t - toques.qualquer > 10000) return { origem: 'outro', detalhe: 'app' };
    return { origem: 'outro', detalhe: 'desconhecido' };
  }
  function esperarRedesenho(fazer, maximo) {
    var feito = false;
    var limite = 0;
    function fim(ev) {
      if (feito) return;
      feito = true;
      d.removeEventListener('cart-update', fim);
      clearTimeout(limite);
      var detalhe = ev && ev.detail;
      setTimeout(function () { fazer(detalhe); }, 0);
    }
    d.addEventListener('cart-update', fim);
    limite = setTimeout(fim, maximo);
  }
  function abriu() {
    var t = agora();
    rolouGaveta = false;
    sug = { inicio: 0, visto: false, enviado: false, rolouLista: false, quando: '', n: 0, timer: 0, maximo: 0 };
    observarSugestoes(true);
    if (t - ultimaAbertura < 1000) return;
    ultimaAbertura = t;
    var origem = origemDaAbertura(t);
    function mandar(detalhe) {
      var g = lerCarrinhoNaTela(detalhe, false);
      medir('gaveta_aberta', { origem: origem.origem, detalhe: origem.detalhe, itens: g.itens, total: g.total,
        meta_frete: g.meta_frete, meta_presente: g.meta_presente, cupons: g.cupons, brinde: g.brinde }, t);
    }
    var wrap = d.querySelector('#halo-cart-sidebar .previewCart-wrapper');
    if (wrap && !wrap.classList.contains('is-loading') && wrap.querySelector('.previewCart')) mandar(null);
    else esperarRedesenho(mandar, 4000);
  }
  function fechou() {
    if (sug) {
      clearTimeout(sug.timer);
      enviarSugestoes();
      sug = null;
    }
  }
  new MutationObserver(function () {
    var agoraAberta = corpo.classList.contains('cart-sidebar-show');
    if (agoraAberta === aberta) return;
    aberta = agoraAberta;
    if (aberta) abriu(); else fechou();
  }).observe(corpo, { attributes: true, attributeFilter: ['class'] });

  // ---------- 6. meta_atingida ----------
  // A meta passa de "não atingida" para "atingida" POR UMA AÇÃO DA CLIENTE NESTA PÁGINA: o estado vem do Liquid
  // (data-ng-estado das barras da gaveta), lido depois de cada redesenho e guardado na aba (sessionStorage ngMedMetas: a
  // recarga não repete). A subida só vira evento se houve, nos 20 s anteriores, uma ação desta página que muda o carrinho
  // (acoes.carrinho); sem ela, a leitura só guarda o estado. Assim não contam: a volta à página guardada do Instagram e do
  // Facebook no Android, a aba nova, a mudança feita em outra aba e o redesenho que um app faz sozinho (revisão de 13/10).
  // Cair e voltar a subir é outra ação. A 1ª leitura da aba só guarda (entrar com a meta cumprida não é ação), exceto com
  // o carrinho vazio numa página NOVA (feita agora pelo servidor): aí o ponto de partida é o começo das metas. Um toque que
  // cruza o fixo e o grátis de uma vez gera só o frete_gratis (de: f1). O frete grátis por cupom de frete (a barra trocada
  // por naguirre-gaveta.js) conta 1 vez até o cupom sair do carrinho, e só com uma ação desta página (calcular o frete,
  // aplicar ou tirar cupom, mudar o carrinho).
  var BASE_FRETE = (cfg.gratis || cfg.fixo) ? (cfg.fixo ? 'f1' : 'f2g') : '';
  var BASE_PRESENTE = cfg.presente ? 'g1' : '';
  var metasNaPagina = null; // reserva sem sessionStorage
  function lerMetas() {
    var m = lerSessao('ngMedMetas');
    if (!m || typeof m !== 'object') m = metasNaPagina || {};
    return m;
  }
  function gravarMetas(m) { metasNaPagina = m; gravarSessao('ngMedMetas', m); }
  function nivelFrete(s) { return s === 'f3' ? 2 : (s === 'f2' || s === 'fx') ? 1 : (s === 'f1' || s === 'f2g') ? 0 : -1; }
  function nivelPresente(s) { return s === 'g2' ? 1 : (s === 'g1' || s === 'g1p') ? 0 : -1; }
  function totalDaGaveta(g) {
    var el = g && g.querySelector('[data-cart-total-value]');
    return inteiro(el && el.getAttribute('data-cart-total-value'), 0, 10000000);
  }
  // Página nova = HTML feito agora pelo servidor. Na volta sem cache de voltar (WebView do Instagram e do Facebook no
  // Android), o HTML vem do cache do navegador (back_forward, 0 byte pela rede) com o carrinho de quando ele foi feito:
  // o itens0 dele é velho e não semeia nada. Sem a medida da navegação, também não semeia.
  function paginaNova() {
    try {
      var nv = w.performance.getEntriesByType('navigation')[0];
      if (!nv || nv.type === 'back_forward' || nv.deliveryType === 'cache') return false;
      return !(nv.transferSize === 0 && nv.decodedBodySize > 0);
    } catch (e) { return false; }
  }
  if (cfg.itens0 === 0 && paginaNova()) {
    var inicio = lerMetas();
    inicio.f = BASE_FRETE;
    inicio.p = BASE_PRESENTE;
    inicio.c = false;
    gravarMetas(inicio);
  }
  function conferirMetas() {
    var g = d.getElementById('halo-cart-sidebar');
    if (!g || !g.querySelector('.previewCart')) return; // gaveta ainda não desenhada
    var m = lerMetas();
    var vazia = !!g.querySelector('.previewCart-emptyBody');
    var f = vazia ? BASE_FRETE : estadoDe(g.querySelector('[data-ng-meta-frete]'), FRETES);
    var p = vazia ? BASE_PRESENTE : estadoDe(g.querySelector('[data-ng-meta-presente]'), PRESENTES);
    var total = totalDaGaveta(g);
    var acao = recente(acoes.carrinho);
    if (acao && typeof m.f === 'string' && nivelFrete(m.f) >= 0 && nivelFrete(f) > nivelFrete(m.f)) {
      medir('meta_atingida', { meta: nivelFrete(f) === 2 ? 'frete_gratis' : 'frete_fixo', como: 'carrinho', de: m.f, gaveta: naGaveta(), total: total });
    }
    if (acao && typeof m.p === 'string' && nivelPresente(m.p) >= 0 && nivelPresente(p) > nivelPresente(m.p)) {
      medir('meta_atingida', { meta: 'presente', como: 'carrinho', de: m.p, gaveta: naGaveta(), total: total });
    }
    m.f = f;
    m.p = p;
    if (vazia) m.c = false;
    else if (m.c) {
      var NC = w.NaguirreCupom;
      if (NC && typeof NC.temCupomDeFrete === 'function' && NC.temCupomDeFrete() === false) m.c = false;
    }
    gravarMetas(m);
  }
  // Gancho de naguirre-gaveta.js (aplicarMetaFrete): a barra de frete virou "Você ganhou frete grátis!" pelo cupom de frete.
  // Sem ação desta página nos 20 s anteriores (aba nova com o cupom e a conta de frete da visita, volta, redesenho de app),
  // só guarda: a meta conta 1 vez, quando a cliente faz a conta, aplica o cupom ou muda o carrinho.
  function freteDoCupom(barra) {
    try {
      var m = lerMetas();
      if (m.c) return;
      var visto = typeof m.f === 'string';
      m.c = true;
      gravarMetas(m);
      if (!visto) return; // 1ª leitura da aba: só guarda
      if (!recente(Math.max(acoes.carrinho, acoes.frete))) return; // sem ação desta página: só guarda
      var de = estadoDe(barra, FRETES);
      medir('meta_atingida', { meta: 'frete_gratis', como: 'cupom_frete', de: de, gaveta: naGaveta(), total: totalDaGaveta(d.getElementById('halo-cart-sidebar')) });
    } catch (e) {}
  }

  // ---------- 7. sugestoes_vistas e 8. sugestao_tocada ----------
  // Vista: 1 vez por abertura, com o bloco ao menos 50% visível por 1 s; vai quando ele sai de vista, a gaveta fecha, a
  // página some ou 20 s depois (assim rolou_lista cobre o tempo todo). Tocar num cartão conta como vista.
  var io = null;
  try { if (typeof w.IntersectionObserver === 'function') io = new w.IntersectionObserver(viuSugestoes, { threshold: [0, 0.5, 1] }); } catch (e) { io = null; }
  var blocoObservado = null;
  function contarCartoes() {
    var b = d.querySelector('#halo-cart-sidebar [data-ng-sugestoes]');
    return b ? inteiro(b.querySelectorAll('.ng-sug__card').length, 0, 10) : 0;
  }
  // forcar (na abertura): observa de novo o mesmo bloco, para o observador dizer já se ele está à vista (a gaveta
  // fechada fica fora da tela pelo transform do tema; se um dia ela só ficar invisível, a abertura ainda conta).
  function observarSugestoes(forcar) {
    if (!io) return;
    var b = d.querySelector('#halo-cart-sidebar [data-ng-sugestoes]');
    if (b && b === blocoObservado && forcar) { try { io.unobserve(b); } catch (e) {} blocoObservado = null; }
    if (b === blocoObservado) return;
    if (blocoObservado) { try { io.unobserve(blocoObservado); } catch (e) {} }
    blocoObservado = b;
    if (sug && !sug.enviado && !sug.visto) { clearTimeout(sug.timer); sug.inicio = 0; } // bloco novo: o 1 s recomeça
    if (b) io.observe(b);
  }
  function marcarVisto() {
    if (!sug || sug.enviado || !sug.inicio) return;
    sug.visto = true;
    sug.n = contarCartoes();
    clearTimeout(sug.maximo);
    sug.maximo = setTimeout(enviarSugestoes, 20000);
  }
  function enviarSugestoes() {
    if (!sug || !sug.visto || sug.enviado) return;
    sug.enviado = true;
    clearTimeout(sug.timer);
    clearTimeout(sug.maximo);
    medir('sugestoes_vistas', { n: sug.n, quando: sug.quando || 'ao_abrir', rolou_lista: !!sug.rolouLista }, sug.inicio || undefined);
  }
  function viuSugestoes(entradas) {
    for (var i = 0; i < entradas.length; i++) {
      var en = entradas[i];
      if (en.target !== blocoObservado || !aberta || !sug || sug.enviado) continue;
      if (en.isIntersecting && en.intersectionRatio >= 0.5) {
        if (!sug.inicio) {
          sug.inicio = agora();
          sug.quando = rolouGaveta ? 'rolou' : 'ao_abrir';
          clearTimeout(sug.timer);
          sug.timer = setTimeout(marcarVisto, 1000);
        }
      } else if (sug.visto) {
        enviarSugestoes();
      } else {
        clearTimeout(sug.timer);
        sug.inicio = 0;
      }
    }
  }
  function tocouSugestao(link) {
    var lista = link.closest('[data-ng-sug-lista]') || link.closest('[data-ng-sugestoes]');
    var links = lista ? lista.querySelectorAll('.ng-sug__link') : [];
    var posicao = Array.prototype.indexOf.call(links, link) + 1;
    if (sug && !sug.enviado) {
      if (!sug.visto) {
        sug.visto = true;
        sug.inicio = sug.inicio || agora();
        sug.quando = sug.quando || (rolouGaveta ? 'rolou' : 'ao_abrir');
        sug.n = contarCartoes();
      }
      enviarSugestoes();
    }
    medir('sugestao_tocada', { posicao: inteiro(posicao, 1, 10), n: inteiro(links.length, 0, 10), produto: handleDe(link.getAttribute('href')) });
  }
  // Rolagem dentro da gaveta: a lista de sugestões (deslize ou setas) e a lista da gaveta (vertical).
  d.addEventListener('scroll', function (ev) {
    var el = ev.target;
    if (!aberta || !el || el.nodeType !== 1 || typeof el.closest !== 'function' || !el.closest('#halo-cart-sidebar')) return;
    if (el.closest('[data-ng-sug-lista]')) { if (sug && !sug.enviado) sug.rolouLista = true; }
    else if (!el.closest('.previewCartInfo')) rolouGaveta = true;
  }, { capture: true, passive: true });

  // ---------- 9. finalizar_tocado ----------
  // Cada toque no "Finalizar a compra" da gaveta ou do /cart, na captura (o beacon sobrevive à troca de página).
  // frete: na gaveta, o que ela mostra (o total "com frete" vale só para este carrinho). No /cart a gaveta costuma estar
  // fechada e sem conta na tela: vale o "já calculou nesta visita" de naguirre-frete.js (a mesma regra que faz a gaveta
  // refazer a conta sozinha para o carrinho novo). Só leitura: nada é calculado nem pedido à loja.
  function freteValeNoCarrinho(naPagina) {
    var li = d.querySelector('#halo-cart-sidebar [data-ng-total]');
    if (li && li.classList.contains('is-com-frete')) return true;
    if (!naPagina) return false;
    try { var NF = w.NaguirreFrete; return !!(NF && typeof NF.jaCalculou === 'function' && NF.jaCalculou()); } catch (e) { return false; }
  }
  function tocouFinalizar(botao) {
    var naPagina = botao.id === 'cart-checkout';
    var g = lerCarrinhoNaTela(null, naPagina);
    if (sug && sug.visto) enviarSugestoes();
    medir('finalizar_tocado', { lugar: naPagina ? 'carrinho' : 'gaveta', itens: g.itens, total: g.total, cupons: g.cupons,
      meta_frete: g.meta_frete, meta_presente: g.meta_presente, frete: freteValeNoCarrinho(naPagina) ? 'calculado' : 'nao' });
  }

  // ---------- Depois de cada redesenho da gaveta ----------
  var redesenhoAgendado = false;
  function depoisDoRedesenho() {
    if (redesenhoAgendado) return;
    redesenhoAgendado = true;
    setTimeout(function () {
      redesenhoAgendado = false;
      try { observarSugestoes(); conferirMetas(); } catch (e) {}
    }, 0);
  }
  d.addEventListener('cart-update', depoisDoRedesenho);
  var wrap0 = d.querySelector('#halo-cart-sidebar .previewCart-wrapper');
  if (wrap0) new MutationObserver(depoisDoRedesenho).observe(wrap0, { childList: true });

  function aoSair() {
    if (sug && sug.visto) enviarSugestoes();
    despachar();
    if (consentimento() === true) guardarCid();
  }
  // O _y desta página vai para a reserva da aba já na carga se o consentimento de análise disser "sim" (página sem
  // evento nenhum também serve de reserva para a próxima); a API pode carregar depois: confere de novo no "load".
  if (consentimento() === true) guardarCid();
  else w.addEventListener('load', function () { if (consentimento() === true) guardarCid(); });
  d.addEventListener('visibilitychange', function () { if (d.visibilityState === 'hidden') aoSair(); });
  w.addEventListener('pagehide', aoSair);

  // ---------- Ganchos públicos (naguirre-gaveta.js e naguirre-frete.js) ----------
  // 5. frete_calculado: lugar 'gaveta' ou 'produto'; info = { resultado | erro: 'cep'|'erro', d: CEP (só para a UF; nunca
  // sai), inicio: Date.now() do toque, memoria: veio da memória da visita }.
  medir.frete = function (lugar, info) {
    try {
      info = info || {};
      var NF = w.NaguirreFrete;
      var dg = String(info.d || '').replace(/\D/g, '');
      var c = { lugar: lugar === 'produto' ? 'produto' : 'gaveta' };
      c.uf = (NF && typeof NF.ufDoCep === 'function' && dg.length === 8 && NF.ufDoCep(dg)) || '';
      if (info.erro) {
        c.resultado = info.erro === 'cep' ? 'cep_recusado' : 'erro';
      } else {
        var r = info.resultado || {};
        var ops = Array.isArray(r.opcoes) ? r.opcoes : [];
        c.resultado = ops.length ? 'ok' : 'sem_opcao';
        c.opcoes = inteiro(ops.length, 0, 20);
        var b = null;
        for (var i = 0; i < ops.length; i++) if (!b || ops[i].centavos < b.centavos) b = ops[i];
        if (b) {
          c.barata = inteiro(b.centavos, 0, 100000);
          c.gratis = b.centavos === 0;
          c.servico = servico(b.nome);
          c.prazo = prazo(b.prazo);
        }
        c.memoria = !!info.memoria;
        c.via = r.viaCarrinho ? 'carrinho' : 'storefront';
      }
      if (typeof info.inicio === 'number') c.ms = inteiro(Date.now() - info.inicio, 0, 60000);
      medir('frete_calculado', c);
    } catch (e) {}
  };
  // 2b. cupom_aplicado pelo link de consultora (/discount/CÓDIGO): 1 vez por código e visita, na 1ª leitura do carrinho
  // que mostra o código do cookie "discount_code". A marca da visita é um resumo local do código; o código não sai daqui.
  var linksNaPagina = [];
  function resumoLocal(texto) {
    var h = 2166136261;
    for (var i = 0; i < texto.length; i++) { h ^= texto.charCodeAt(i); h = (h * 16777619) >>> 0; }
    return h.toString(36);
  }
  medir.link = function (resumo, cookie) {
    try {
      var COD = String(cookie || '').replace(/\s+/g, '').toUpperCase();
      if (!COD || !resumo || !Array.isArray(resumo.cupons)) return;
      var cup = null;
      for (var i = 0; i < resumo.cupons.length; i++) if (String(resumo.cupons[i].code).toUpperCase() === COD) cup = resumo.cupons[i];
      if (!cup) return;
      var marca = resumoLocal(COD);
      var vistos = lerSessao('ngMedLink');
      if (!Array.isArray(vistos)) vistos = [];
      if (vistos.indexOf(marca) !== -1 || linksNaPagina.indexOf(marca) !== -1) return;
      linksNaPagina.push(marca);
      vistos.push(marca);
      gravarSessao('ngMedLink', vistos.slice(-20));
      medir('cupom_aplicado', { via: 'link', lugar: 'pagina', resultado: cup.applicable ? 'aceito' : 'pendente',
        motivo: cup.applicable ? 'link_valido' : 'link_nao_vale', familia: familia(COD),
        tipo: cup.applicable ? (cup.nasPecas ? 'pecas' : 'frete') : 'nenhum',
        combo: !!(resumo.promocoes && resumo.promocoes.length) });
    } catch (e) {}
  };
  medir.familia = familia;
  medir.freteDoCupom = freteDoCupom;
  w.ngMedir = medir;
})();
